import React,{useEffect} from 'react'

import { 
 
    Route,
    Routes,     
    Navigate,
    Outlet,
  
   } from 'react-router-dom'

import Home from './Pages/Home'
import Login from './Pages/Login';
import { useSelector } from 'react-redux';
import Signup from './Pages/Signup';
import Products from './Pages/Products';
import ProductDetails from './Pages/ProductDetails';
import PhotoGalleryEvent from './Pages/PhotoGalleryEvent';
import PhotoGallery from './Pages/PhotoGallery';
import PhotoGalleryImages from './Pages/PhotoGalleryImages';
import Reports from './Pages/Reports';
import ReportAdmin from './Pages/ReportAdmin';
import ExamDashboard from './Pages/ExamDashboard';
import CreateAgents from './Pages/CreateAgents';
import ReportDashboardAdmin from './Pages/ReportDashboardAdmin';
import ReportAdminOfAgents from './Pages/ReportAdminOfAgents';
import ReportAdminFormWithFilter from './Pages/ReportAdminFormsWithFilter';
import ReportAdminOfAgentForms from './Pages/ReportAdminOfAgentForms';
import DepositProofForm from './Pages/DepositProofForm';
import ExamSchools from './Pages/ExamSchools';
import ExamFormPage from './Pages/ExamFormPage';
import ConsolidatedReportPage from './Pages/ConsolidatedReportPage';
import DeletedFormsList from './Pages/DeletedFormsList';

// import Courses from './Pages/Courses';
// import CourseContent from './Pages/CourseContent';
// import Reports from './Pages/Reports';

function AppRoutes() {
   const isLoggedin = useSelector(state => state.userData.user_data == null ? false : true);
  
    const ProtectedRoute = ({
        isAllowed,
        redirectPath = '/',
        children,
      }) => {
        if (!isAllowed) {
          return <Navigate to={redirectPath} replace />;
        }
      
        return children ? children : <Outlet />;
      };
  return (
    <>
 
   <Routes>
   <Route index element={<Login/>}/>  
   <Route path="/signup" element={<Signup/>}/>    
   <Route path="/login" element={<Login/>}/>    

   <Route element={<ProtectedRoute isAllowed={isLoggedin} />}>
   <Route path="/examdashboard" element={<ExamDashboard/>}/>
   <Route path="/examform" element={<ExamFormPage/>}/>
   <Route path="/consolidatedReport" element={<ConsolidatedReportPage/>}/>
   <Route path="/examschools" element={<ExamSchools/>}/>    

   <Route path="/dashboard" element={<Home/>}/>    
    <Route path="/reportDashboardAdmin" element={<ReportDashboardAdmin/>}/>    
   <Route path="/products" element={<Products/>}/>    
   <Route path="/productdetails" element={<ProductDetails/>}/>    

   <Route path="/photogallery" element={<PhotoGallery/>}/>    
   <Route path="/photogalleryevent" element={<PhotoGalleryEvent/>}/>    
   <Route path="/photogalleryimages" element={<PhotoGalleryImages/>}/>    
   <Route path="/reports" element={<Reports/>}/>    
   <Route path="/reportsadmin" element={<ReportAdmin/>}/>   
   <Route path="/reportadminofagents" element={<ReportAdminOfAgents/>}/>    
   <Route path="/reportAllExamFormsForAdminFilter" element={<ReportAdminFormWithFilter/>}/>    
   <Route path="/DepositProofForm" element={<DepositProofForm/>}/>    


   <Route path="/reportAdminOfAgentForms/:agentId/:agentName" element={<ReportAdminOfAgentForms/>}/>

   <Route path="/createagent" element={<CreateAgents/>}/>
   <Route path="/deletedForms" element={<DeletedFormsList/>}/>

   {/* <Route path="/courses" element={<Courses/>}/>       
   <Route path="/coursecontent" element={<CourseContent/>}/>   
   <Route path="/reports" element={<Reports/>}/>    */}

   {/* <Route path="dashboard" element={<Reports/>}/>     */}


        </Route>
    </Routes>
  
  
    </>
  )
}

export default AppRoutes